import {Injectable} from '@angular/core';
import {
  FilterChoice,
  LicenseTypeChoice,
  PlatformChoice
} from './product-filter-chooser/product-filter-chooser.component';
import {LicenseType, Product} from '@uofu-uss-aux/software-catalog-ng-core';

@Injectable({
  providedIn: 'root'
})
export class ProductFilterService {

  constructor() {
  }

  static platformMatches(platform: string, platformChoice: PlatformChoice): boolean {
    switch (platformChoice) {
      case PlatformChoice.Windows:
        return platform === 'Windows';
      case PlatformChoice.Mac:
        return platform === 'Mac';
      case PlatformChoice.Linux:
        return platform === 'Linux';
      case PlatformChoice.Other:
        return platform !== 'Windows'
          && platform !== 'Mac'
          && platform !== 'Linux';
      case undefined:
        return true;
    }
  }

  static licenseTypeMatches(licenseType: LicenseType, licenseTypeChoice: LicenseTypeChoice): boolean {
    switch (licenseTypeChoice) {
      case LicenseTypeChoice.Student:
        return licenseType === LicenseType.Student;
      case LicenseTypeChoice.Employee:
        return licenseType === LicenseType.Employee;
      case LicenseTypeChoice.University:
        return licenseType === LicenseType.University;
      case undefined:
        return true;
    }
  }

  static hasFilterChosen(filterChoice?: FilterChoice) {
    return filterChoice?.platformChoice !== undefined
      || filterChoice?.licenseTypeChoice !== undefined;
  }

  static filterPlatform(product: Product, platformChoice: PlatformChoice): boolean {
    return product.licenses
      .flatMap(license => license.offerings
        .flatMap(offering => offering.platform.title))
      .filter(title => ProductFilterService.platformMatches(title, platformChoice)).length > 0;
  }

  static filterLicenseTypes(product: Product, licenseTypeChoice: LicenseTypeChoice): boolean {
    return product.licenses
      .map(license => license.type)
      .filter(type => ProductFilterService.licenseTypeMatches(type, licenseTypeChoice)).length > 0;
  }

  static filterOnChoice(products: readonly Product[], {platformChoice, licenseTypeChoice}: FilterChoice): Product[] {
    return products
      .filter(p => ProductFilterService.filterPlatform(p, platformChoice))
      .filter(p => ProductFilterService.filterLicenseTypes(p, licenseTypeChoice));
  }
}
